<template>
  <div class="login">
    <div class="row justify-content-md-center" style="margin-top:10px;">
      <div class="col-lg-4 col-12">
        <b-alert variant="success" show v-if="!error">Merci de créer votre compte avant de souscrire un nouvel abonnement</b-alert>
        <b-alert variant="danger" show v-if="error">{{ error }}</b-alert>
        <br/>
        <div class="text-center">
          <div class="btn-group text-center">
            <b-button variant="info" disabled><icon name="brands/twitter"></icon></b-button>
            <b-button variant="info" v-on:click="twLogin()"> S'enregistrer avec Twitter</b-button>
          </div>
        </div>
        <br/>
        <div class="row">
          <div class="col"><hr style="background: white;"></div>
          <div class="col-auto" style="color: white;">OU</div>
          <div class="col"><hr style="background: white;"></div>
        </div>
        <b-form @submit="onSubmit" v-if="show">
          <b-form-group id="input-group-firstname" label="Prénom:" label-for="input-firstname">
            <b-form-input
              id="input-firstname"
              v-model="form.firstname"
              type="text"
              placeholder="Prénom"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group id="input-group-lastname" label="Nom:" label-for="input-lastname">
            <b-form-input
              id="input-lastname"
              v-model="form.lastname"
              type="text"
              placeholder="Nom"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group id="input-group-email" label="Email:" label-for="input-email">
            <b-form-input
              id="input-email"
              v-model="form.email"
              type="email"
              placeholder="Adresse Email"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group id="input-group-2" label="Mot de passe:" label-for="input-password">
            <b-form-input
              id="input-password"
              v-model="form.password"
              type="password"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group id="input-group-password2" label="Confirmation du mot de passe:" label-for="input-password2">
            <b-form-input
              id="input-password2"
              v-model="form.password2"
              type="password"
              required
            ></b-form-input>
          </b-form-group>

          <div class="text-center">
            <b-button type="submit" variant="outline-light">
              <span v-if="!loader">Créer mon compte</span>
              <b-spinner small type="grow" v-if="loader"></b-spinner> <span v-if="loader">Validation en cours...</span>
            </b-button>
          </div>
        </b-form>        
        <router-link class="float-right" :to="{ name: 'connexion', query: { redirect: $route.query.redirect }}">Se connecter</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from '@/firebase.js'
import { auth } from '@/firebase.js'

export default {
  data: () => ({ form: { firstname: '', lastname: '', email: '', password: '', password2: '' }, loader: false, show: true, error: null, auth: auth }),
  methods: {
    onSubmit(evt) {
      evt.preventDefault()
      if(this.loader) return;
      if(this.form.password !== this.form.password2) {
        this.error = "Confirmation de mot de passe incorrect"
      } else {
        this.loader = true
        auth.createUserWithEmailAndPassword(this.form.email, this.form.password, this.form.firstname + ' ' + this.form.lastname.toUpperCase())
        .then(() => this.$router.replace(this.$route.query.redirect ? this.$route.query.redirect : '/'))
        .catch((error) => {
          this.error = error.message
          this.loader = false
        });
      }
    },
    twLogin: function () {
      var provider = new firebase.auth.TwitterAuthProvider();
      auth.signInWithPopup(provider).then(() => this.$router.replace(this.$route.query.redirect ? this.$route.query.redirect : '/'))
      .catch((error) => {
        this.error = error.message
      });
    }
  }
}
</script>

<style>
.button {
  cursor: pointer;
}
</style>